import { useI18n } from "@/lib/i18n";
import { useMobilI18n } from "@/lib/mobilI18n";
import { BRAND } from "@/lib/brand";
import { Instagram } from "lucide-react";

export default function Footer({ linkBase = "" }) {
  const { t } = useI18n();
  const { m } = useMobilI18n();
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="footer"
      className="bg-[#2e5949] text-[#fdfcf9]/75 px-6 md:px-12 lg:px-24 py-14"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <img src={BRAND.logoUrl} alt="Aura" className="h-10 brightness-0 invert mb-4" />
          <p className="max-w-xs text-sm leading-relaxed">
            Sala d'esdeveniments a Sant Cugat del Vallès. Aniversaris, cates, sopars d'empresa i nits inoblidables.
          </p>
          <a
            href={BRAND.instagramUrl}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-instagram"
            aria-label="Instagram Aura Sant Cugat"
            className="mt-5 inline-flex items-center gap-2 text-sm text-[#fdfcf9]/85 hover:text-[#E2C9A0] transition-colors"
          >
            <span className="w-9 h-9 rounded-full border border-[#fdfcf9]/20 flex items-center justify-center hover:border-[#E2C9A0] transition-colors">
              <Instagram size={16} />
            </span>
            {BRAND.instagramHandle}
          </a>
        </div>
        <div>
          <p className="uppercase tracking-[0.22em] text-[10px] text-[#E2C9A0] mb-3">{t.footer.nav}</p>
          <ul className="space-y-2 text-sm">
            <li><a href={`${linkBase}#sala`} className="hover:text-[#fdfcf9]">{t.nav.sala}</a></li>
            <li><a href={`${linkBase}#eventos`} className="hover:text-[#fdfcf9]">{t.nav.eventos}</a></li>
            <li><a href={`${linkBase}#disponibilidad`} className="hover:text-[#fdfcf9]">{t.nav.disponibilidad}</a></li>
            <li><a href={`${linkBase}#galeria`} className="hover:text-[#fdfcf9]">{t.nav.galeria}</a></li>
            <li><a href={`${linkBase}#contacto`} className="hover:text-[#fdfcf9]">{t.nav.contacto}</a></li>
            <li><a href="/eventos-externos" data-testid="footer-mobil-link" className="text-[#E2C9A0] hover:text-[#fdfcf9]">{m.name}</a></li>
          </ul>
        </div>
        <div>
          <p className="uppercase tracking-[0.22em] text-[10px] text-[#E2C9A0] mb-3">{t.footer.contact}</p>
          <p className="text-sm" data-testid="footer-phone">{BRAND.phoneInfo}</p>
          <p className="text-sm mt-1" data-testid="footer-email">{BRAND.ownerEmail}</p>
          <p className="text-sm mt-1">Rambla del Celler, 93</p>
          <p className="text-sm">Sant Cugat del Vallès</p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto mt-12 pt-6 border-t border-[#fdfcf9]/10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs uppercase tracking-[0.22em] text-[#fdfcf9]/40">
        <span>{t.footer.rights.replace("{year}", String(year))}</span>
        <a href="/admin/login" data-testid="footer-admin-link" className="hover:text-[#fdfcf9]">{t.footer.adminLink}</a>
      </div>
    </footer>
  );
}
